<template>
  <div class="v-table__overflow">
    <div
      class="v-data-table theme--light"
      :class="positionHeader"
    >
      <div
        id="visible-items"
        class="v-data-table__wrapper"
        :style="{
          height: tableHeight + 'px',
          overflow: 'auto',
          'background-color': '#fff'
        }"
      >
        <table class="v-datatable v-table theme--light">
          <thead>
            <slot name="header">
              <tr>
                <th
                  v-for="(header, index) in columns"
                  :key="index"
                  :style="{
                    'white-space': 'pre-line',
                    'text-align': 'left',
                    'min-width': `${header.minWidth ? header.minWidth : 40}px`,
                    width: `${header.minWidth ? header.minWidth : 40}px`
                  }"
                >
                  <template v-if="header.type === 'icon'">
                    <DataTableFilter
                      @change="applyFilter"
                      @clear="initfilter"
                    />
                  </template>
                  <template v-else-if="header.cellFiltering">
                    <v-layout>
                      <span>{{ header.title }}</span>
                      <CellMultipleFilter
                        v-model="filter[header.name]"
                        :items="filterItemsByColumn(header.name)"
                        :column="header.name"
                        :label="header.title"
                        @change="changeCellFilter"
                      />
                    </v-layout>
                  </template>
                  <template v-else>
                    <v-layout>
                      <span>{{ header.title }}</span>
                      <v-icon
                        v-if="
                          isChangedFilter ? getFilterIcon(header.name) : false
                        "
                        small
                        color="blue darken-1"
                      >
                        filter_list
                      </v-icon>
                    </v-layout>
                  </template>
                </th>
              </tr>
            </slot>

            <DataTableProgressLine
              v-if="itemsLoading || loadingVisibleItems"
              :items-length="columns.length"
            />
          </thead>
          <tbody>
            <template v-if="visibleItems.length > 0">
              <template v-for="(item, index) in visibleItems">
                <TableRow
                  v-show="item.visible"
                  :key="index"
                  :headers="columns"
                  :shipping="item"
                  :is-familiarized-show="isFamiliarizedShow"
                >
                  <template v-slot:prepend-cell>
                    <slot
                      name="prepend-cell"
                      :item="item"
                    />
                  </template>
                  <template v-slot:checkbox-cell>
                    <slot
                      name="checkbox-cell"
                      :item="item"
                    />
                  </template>
                </TableRow>
              </template>
            </template>
            <template v-else>
              <tr>
                <td
                  :colspan="columns.length"
                  style="text-align:center;background-color:#fff;"
                >
                  Нет данных
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TableRow from "./TableRow.vue";
import DataTableFilter from "./DataTableFilter.vue";
import CellMultipleFilter from "../../../components/CellMultipleFilter.vue";
import DataTableProgressLine from "../../../components/DataTableProgressLine.vue";
import { phaseTypes } from "./shipping-phase-types.js";
import _ from "lodash";

export default {
  name: "DataTableFixedHeader",
  components: {
    TableRow,
    DataTableFilter,
    CellMultipleFilter,
    DataTableProgressLine,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    fixedHeader: {
      type: Boolean,
    },
    tableHeight: {
      type: Number,
      required: true,
      default: 430,
    },
    groups: {
      type: Array,
      required: true,
    },
    isFamiliarizedShow: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      phaseTypes,
      cellColor: "#E0E0E0",
      filter: {},
      templateItems: [],
      isChangedFilter: false,
      visibleItems: [],
      loadingVisibleItems: false,
    };
  },
  computed: {
    flatItems() {
      let prevItem = null;
      let nextItem = null;
      const groupedItems = getGroupShippings(this.templateItems, this.groups);

      let flatItems = [];
      for (const key in groupedItems) {
        flatItems = flatItems.concat(
          groupedItems[key].map(item => {
            const result = { ...item };
            result.visible = true;
            result.regionColor = this.getCellColor(
              prevItem,
              result,
              "regionColor",
              "region",
            );
            result.districtColor = this.getCellColor(
              prevItem,
              result,
              "districtColor",
              "district",
            );
            prevItem = result;
            return result;
          }),
        );
      }

      return flatItems.map((i, index) => {
        if (
          prevItem &&
          nextItem &&
          i.regionColor &&
          (i.region === prevItem.region || i.region.id === nextItem.region.id)
        ) {
          i.cellBorder =
            "border-right: 2px solid black; border-left: 2px solid black;";
        }
        if (prevItem && i.regionColor && i.region.id !== prevItem.region.id) {
          i.cellBorder =
            "border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;";
        }
        if (
          (nextItem && i.regionColor && i.region.id !== nextItem.region.id) ||
          (prevItem && !nextItem && i.regionColor)
        ) {
          i.cellBorder =
            "border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;";
        }
        if (
          prevItem &&
          nextItem &&
          i.regionColor &&
          i.region.id !== prevItem.region.id &&
          i.region.id !== nextItem.region.id
        ) {
          i.cellBorder = "border: 2px solid black;";
        }
        prevItem = i;
        nextItem = flatItems[index + 2];
        return i;
      });

      function getGroupShippings(shippings, groups) {
        const sortedItems = shippings.sort((a, b) => {
          const aTerm = groups
            .map(g => {
              let result = "";
              const item = a[g];
              return (result += item && item.title ? item.title : item);
            })
            .join();
          const bTerm = groups
            .map(g => {
              let result = "";
              const item = b[g];
              return (result += item && item.title ? item.title : item);
            })
            .join();

          if (aTerm < bTerm) {
            return -1;
          }
          if (aTerm > bTerm) {
            return 1;
          }
          return 0;
        });

        return _.groupBy(sortedItems, i => {
          return groups.map(g => {
            const item = i[g];
            return item?.title?.replace(",", "#comma#") || item;
          });
        });
      }
    },
    positionHeader() {
      if (this.fixedHeader && this.maxHeightTable != "none") {
        return "v-data-table--fixed-header";
      } else {
        return "v-data-table--fixed-height";
      }
    },
    itemsLoading() {
      return this.$store.getters["routePlanning/shippingsLoading"];
    },
    items() {
      return this.$store.getters["routePlanning/getPlanningData"];
    },
    storeFilter() {
      return this.$store.getters["routePlanning/dataTableFilter"];
    },
    changedItemRow() {
      return this.$store.getters["routePlanning/changedItemRow"];
    },
  },
  watch: {
    items: {
      handler(value) {
        this.templateItems = value;
        this.applyFilter(this.storeFilter);
      },
      deep: true,
    },
    loading: {
      handler(value) {
        this.loadingVisibleItems = value;
      },
    },
  },
  mounted() {
    const itemRow = document.querySelector("#visible-items");
    itemRow.addEventListener("scroll", () => {
      if (itemRow.scrollTop + itemRow.offsetHeight >= itemRow.scrollHeight) {
        this.getVisibleItems();
      }
    });
  },
  created() {
    if (this.storeFilter) {
      this.applyFilter(this.storeFilter);
      return;
    }
    this.initfilter();
  },
  methods: {
    getVisibleItems(isFilterChanged) {
      if (this.changedItemRow) {
        this.$store.commit("routePlanning/setChangedItemRow", false);
        this.visibleItems.forEach(i => {
          const phase = this.flatItems.find(v => v.phaseId === i.phaseId);
          if (!phase) {
            return;
          }
          i.draft = phase.draft;
          i.route = phase.route;
          i.routeColor = phase.routeColor;
          i.isFamiliarized = phase.isFamiliarized;
          i.factoryClosingDate = phase.factoryClosingDate;
          i.routeItemId = phase.routeItemId;
        });
        return;
      }
      if (isFilterChanged) {
        this.visibleItems = [];
      }
      if (this.visibleItems.length === this.flatItems.length) {
        return;
      }
      const diff = this.flatItems.length - this.visibleItems.length;
      const length =
        diff < 30 ? this.flatItems.length : this.visibleItems.length + 30;
      this.loadingVisibleItems = true;
      setTimeout(() => {
        for (let i = this.visibleItems.length; i < length; i++) {
          this.visibleItems.push(this.flatItems[i]);
        }
        this.loadingVisibleItems = false;
      }, 500);
    },
    getFilterItems(value) {
      if (!this.items.length) {
        return;
      }

      this.filter = value;
      this.$store.commit("routePlanning/setDataTableFilter", {
        ...this.filter,
      });
      this.templateItems = [];
      this.templateItems = this.items.filter(item => {
        return (
          (this.filter?.volume.from
            ? item.volume >= this.filter.volume.from
            : true) &&
          (this.filter?.volume.to
            ? item.volume < this.filter.volume.to
            : true) &&
          (this.filter?.weight.from
            ? item.weight >= this.filter.weight.from
            : true) &&
          (this.filter?.weight.to
            ? item.weight < this.filter.weight.to
            : true) &&
          (this.filter?.readyDate.from
            ? item.readyDate >= this.filter.readyDate.from
            : true) &&
          (this.filter?.readyDate.to
            ? item.readyDate < this.filter.readyDate.to
            : true) &&
          (this.filter?.route?.id
            ? item.route?.id === this.filter.route.id ||
              item.draft?.id === this.filter.route.id
            : true) &&
          (this.filter?.shipping?.id
            ? item.shipping?.id === this.filter.shipping.id
            : true) &&
          (this.filter?.sender ? item.sender === this.filter.sender : true) &&
          (this.filter?.deliveryToUnloadingPlaceDate.from
            ? item.deliveryToUnloadingPlaceDate >=
              this.filter.deliveryToUnloadingPlaceDate.from
            : true) &&
          (this.filter?.deliveryToUnloadingPlaceDate.to
            ? item.deliveryToUnloadingPlaceDate <
              this.filter.deliveryToUnloadingPlaceDate.to
            : true) &&
          (this.filter?.phaseType?.id
            ? item.phaseType?.id === this.filter.phaseType.id
            : true) &&
          (this.filter?.warehouseType
            ? item.warehouseType === this.filter.warehouseType
            : true) &&
          (this.filter?.arriveToWarehouseDate.from
            ? item.arriveToWarehouseDate >=
              this.filter.arriveToWarehouseDate.from
            : true) &&
          (this.filter?.arriveToWarehouseDate.to
            ? item.arriveToWarehouseDate < this.filter.arriveToWarehouseDate.to
            : true) &&
          (this.filter?.carLoadingDate.from
            ? item.carLoadingDate >= this.filter.carLoadingDate.from
            : true) &&
          (this.filter?.carLoadingDate.to
            ? item.carLoadingDate < this.filter.carLoadingDate.to
            : true) &&
          (this.filter?.region.length > 0
            ? this.filter.region.find(r => r.id === item.region?.id)
            : true) &&
          (this.filter?.district.length > 0
            ? this.filter.district.find(d => d.id === item.district?.id)
            : true) &&
          (this.filter?.city.length > 0
            ? this.filter.city.find(c => c.id === item.city?.id)
            : true) &&
          (this.filter?.postcode.length > 0
            ? this.filter.postcode.find(p => p === item.postcode)
            : true) &&
          (this.filter?.loadingPlace.length > 0
            ? this.filter.loadingPlace.find(l => l === item.loadingPlace)
            : true) &&
          (this.filter?.warehouse.length > 0
            ? this.filter.warehouse.find(w => w === item.warehouse)
            : true) &&
          (this.filter?.client.length > 0
            ? this.filter.client.find(с => с.id === item.client?.id)
            : true) &&
          (this.filter?.clientAlias.length > 0
            ? this.filter.clientAlias.find(cA => cA === item.clientAlias)
            : true) &&
          (this.filter?.productDescription.length > 0
            ? this.filter.productDescription.find(
              p => p === item.productDescription,
            )
            : true)
        );
      });
      this.getVisibleItems(true);
    },
    initfilter() {
      this.filter = {
        volume: {
          from: null,
          to: null,
        },
        weight: {
          from: null,
          to: null,
        },
        readyDate: {
          from: null,
          to: null,
        },
        route: { id: 0, title: "" },
        shipping: { id: 0, title: "" },
        sender: "",
        deliveryToUnloadingPlaceDate: {
          from: null,
          to: null,
        },
        phaseType: { id: 0, title: "" },
        warehouseType: "",
        arriveToWarehouseDate: {
          from: null,
          to: null,
        },
        carLoadingDate: {
          from: null,
          to: null,
        },
        region: [],
        district: [],
        city: [],
        postcode: [],
        loadingPlace: [],
        warehouse: [],
        client: [],
        clientAlias: [],
        productDescription: [],
      };
      this.$store.commit("routePlanning/setDataTableFilter", this.filter);
    },
    changeCellFilter(value) {
      this.filter[value.column] = value.filter;
      this.applyFilter(this.filter);
    },
    applyFilter(value) {
      this.getFilterItems(value);
      this.isChangedFilter = true;
    },
    getCellColor(prevItem, result, colorProperty, itemProperty) {
      if (!prevItem) {
        return;
      }

      const current = result[itemProperty]?.id;
      const previous = prevItem[itemProperty]?.id;
      if (
        current &&
        previous &&
        current != previous &&
        !prevItem[colorProperty]
      ) {
        return this.cellColor;
      } else if (current && previous && current === previous) {
        return prevItem[colorProperty];
      } else {
        return result.regionColor;
      }
    },
    getFilterIcon(value) {
      if (!Object.prototype.hasOwnProperty.call(this.filter, value)) {
        return false;
      }
      return this.filter[value]?.from
        ? true
        : this.filter[value]?.to
          ? true
          : this.filter[value]?.id
            ? true
            : this.filter[value] && typeof this.filter[value] === "string"
              ? true
              : false;
    },
    filterItemsByColumn(column) {
      if (!this.items.length) {
        return;
      }

      const filteredItems = [];
      this.items.forEach(i => {
        if (!i[column]) {
          return;
        }
        filteredItems.push(i[column]);
      });
      return _.uniqWith(filteredItems, _.isEqual);
    },
  },
};
</script>
